// client/src/pages/adminpages/CPSSettlementPendingPage.js
import React from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import CPSSettlementReservationList from '../../components/admin/cps/CPSSettlementReservationList';

function CPSSettlementPendingPage() {
  return (
    <AdminLayout title="CPS 정산 대기 관리">
      <CPSSettlementReservationList />
    </AdminLayout>
  );
}

export default CPSSettlementPendingPage;
